import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import { Observable } from "rxjs";

import SdkAnalyticsEventsFactory from "../analytics/SdkAnalyticsEventsFactory";
import { SDK_MODULES } from "../constants";
import { sendRunIfModuleReadyCalledEvent } from "../helpers";
import Sdk from "../Sdk";
import { COMMON_SDK_EVENTS } from "./constants";

class CommonSdkEvents {
    constructor(
        private readonly _sdk: Sdk,
        private readonly _eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly _sdkEventsFactory: SdkAnalyticsEventsFactory,
        private readonly _isEventsSenderStarted$: Observable<boolean>
    ) {}

    public readonly WIDGET_CLOSED = COMMON_SDK_EVENTS.WIDGET_CLOSED;
    public readonly WIDGET_INJECTED = COMMON_SDK_EVENTS.WIDGET_INJECTED;
    public readonly WIDGET_OPENED = COMMON_SDK_EVENTS.WIDGET_OPENED;
    public readonly MODAL_OPENED = COMMON_SDK_EVENTS.MODAL_OPENED;
    public readonly MODAL_CLOSED = COMMON_SDK_EVENTS.MODAL_CLOSED;

    /**
     * @deprecated This method has been moved to the SDK core.
     *
     * Compatibility details:
     * - Previously used as: `gw.sdk.common.events.runIfModuleReady`.
     * - Kept for backward compatibility to support existing users.
     */
    public runIfModuleReady(
        moduleName: Exclude<SDK_MODULES, SDK_MODULES.COMMON>,
        callback: () => void
    ): void {
        sendRunIfModuleReadyCalledEvent(
            this._eventsCollector,
            this._sdkEventsFactory,
            this._isEventsSenderStarted$
        );

        console.error(
            "[Growave SDK Method Deprecated Warning]: The method 'runIfModuleReady' in 'sdk.common.events' is deprecated. Please use 'runIfModuleReady' from 'sdk.runIfModuleReady' instead. Refer to the latest SDK documentation for more details."
        );
        this._sdk.runIfModuleReady(moduleName, callback);
    }
}

export default CommonSdkEvents;
